<div id="outer">
  <app-header bare="true"></app-header>
  <div id="inner">
    <div id="content">
      @if (confirmed() === true) {
        <h2><span i18n>Thank you!</span></h2>
        <p><span i18n>Your email was verified.</span></p>
        @if (loading()) {
          <mat-spinner diameter="40" style="margin: auto"></mat-spinner>
        } @else {
          <button
            mat-flat-button
            [routerLink]="redirection()"
            i18n="nav button label"
          >
            Continue to enrollment
          </button>
        }
      }
      @if (confirmed() === false) {
        <h2><span i18n>We're sorry!</span></h2>
        @if (result === 'missing') {
          <p>
            <span i18n>There was a problem verifying your email.</span>
            <span i18n="Please email (this address)">Please email</span>
          </p>
        } @else {
          <p>
            <span i18n>There was a problem verifying your email.</span>
            <span i18n>Please click the verification link again.</span>
            <span i18n>If verification continues to fail please email</span>
          </p>
        }
        <p>
          <a [href]="STR.SUPPORT_HREF"
            ><span>{{ STR.SUPPORT_EMAIL }}</span></a
          >
        </p>
      }
    </div>
  </div>
</div>
